export var COPY_PERSONAL_DETAILS_UPDATE_FAILURE = "Sorry, there was an issue updating your details. Please try again.";
export var COPY_PERSONAL_DETAILS_UPDATE_SUCCESS = "Your details have been updated.";
export var COPY_GENERIC_ERROR = "Something went wrong. Please try again later."; // CHANGE PASSWORD

export var COPY_RESET_PASSWORD_ERROR_MESSAGE = "Error resetting password. Please try again later.";
export var RESET_PASSWORD_ENDPOINT = "/reset-password.json";